import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';

import currency from 'utils/currency';
import ImageBell from 'assets/images/bell.svg';
import {
  Hr,
  AdjustmentWeightDiv,
  AdjustmentNotificationDiv,
  TransactionAdjustmentCard
} from 'components/Styled';

export const AdjustmentAlertCard = props => {
  const { image, html } = props;
  return (
    <TransactionAdjustmentCard className="text-center">
      <AdjustmentNotificationDiv>
        <img className="bell-img image-filter theme" src={image} alt="" />
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: html
          }}
        />
      </AdjustmentNotificationDiv>
    </TransactionAdjustmentCard>
  );
};

export const AdjustmentWeightCard = props => {
  const { t } = useTranslation();
  const transaction = get(props, 'transaction');
  const shipment = get(transaction, 'shipments[0]');
  const shipments = get(transaction, 'shipments');
  let firstCharges, finalCharges;
  if (shipments.length === 1) {
    firstCharges = transaction.totalCharges;
    finalCharges = transaction.finalTotal;
  } else {
    firstCharges = shipment.firstRate;
    finalCharges = shipment.TotalRate;
  }

  firstCharges = new currency(firstCharges);
  finalCharges = new currency(finalCharges);
  return (
    <TransactionAdjustmentCard>
      <div className="adjustment-header m-b-15 title">
        {t('confirmAdjustment.header')}
        {/* <span className="button-icon" onClick={() => {}}>
          <FontAwesomeIcon icon="info-circle" />
        </span> */}
      </div>
      <Hr />
      <div className="content">
        <AdjustmentWeightDiv>
          <div className="">
            <p className="small-font">
              {t('confirmAdjustment.estimatedChargeableWeight')}
            </p>
            <span className="xxxlarge-font weight">
              {shipment.previewWeight}{' '}
            </span>
            <small className="large-font">kg</small>
            <FontAwesomeIcon className="arrow-icon" icon="angle-right" />
          </div>
          <div>
            <p className="small-font">
              {t('confirmAdjustment.chargeableWeight')}
            </p>
            <span className="xxxlarge-font weight">
              {shipment.chargeableWeight}{' '}
            </span>
            <small className="large-font">kg</small>
          </div>
        </AdjustmentWeightDiv>
        <AdjustmentWeightDiv>
          <div className="">
            <p className="small-font">
              {t('confirmAdjustment.estimatedCharges')}
            </p>
            <small className="large-font">
              {(firstCharges).currency}
            </small>
            <span className="xxxlarge-font price">
              {(firstCharges).format(false, true)}
            </span>
            <FontAwesomeIcon className="arrow-icon" icon="angle-right" />
          </div>
          <div>
            <p className="small-font">
              {t('confirmAdjustment.adjustmentCharges')}
            </p>
            <small className="large-font">
              {(finalCharges).currency}
            </small>
            <span className="xxxlarge-font price">
              {(finalCharges).format(false, true)}
            </span>
          </div>
        </AdjustmentWeightDiv>
      </div>
    </TransactionAdjustmentCard>
  );
};

const TransactionAdjustmentContent = props => {
  const { t } = useTranslation();
  const shipment = props.shipment;
  const transaction = props.transaction;
  return (
    <>
      <AdjustmentAlertCard
        image={ImageBell}
        html={t('confirmAdjustment.remarks')}
      />
      <AdjustmentWeightCard shipment={shipment} transaction={transaction} />
    </>
  );
};

export default TransactionAdjustmentContent;
